import { Box, CircularProgress } from '@mui/material';
import React from 'react';

import palette from '../../../../ColorPalette';
import { imageHeight } from '../utils/analysis';

interface FrontFacingOverlayProps {
    horizontalPixel?: number;
}

export const FrontFacingOverlay: React.FC<FrontFacingOverlayProps> = (props) => {
    if (props.horizontalPixel === undefined) {
        return (
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                    backgroundColor: palette.white,
                    opacity: 0.5,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
            >
                <CircularProgress title="test3" value={25} />
            </Box>
        );
    }
    return (
        <Box
            sx={{
                width: '100%',
                height: '0px',
                borderTop: '1px solid white',
                borderBottom: '1px solid white',
                position: 'absolute',
                top: `${(props.horizontalPixel / imageHeight) * 100}%`,
                boxShadow: '0px 0px 5px 1px #000, inset 0px 0px 5px 1px #000',
            }}
        />
    );
};

export default FrontFacingOverlay;
